import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { AfterViewInit, Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { CreateRfidCardComponent } from '@components/entities/rfid-cards/create-rfid-card/create-rfid-card.component';
import { IEntity } from '@interfaces/entity';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RfidCardsService } from '@services/entity/rfidCards.service';
import { FormService } from '@services/form/form.service';

@Component({
  selector: 'app-create-rfid-card-dialog-content',
  templateUrl: './create-rfid-card-dialog-content.component.html',
  styleUrls: ['./create-rfid-card-dialog-content.component.scss']
})
export class CreateRfidCardDialogContentComponent extends AbstractDialogContent implements OnInit, AfterViewInit {

  public className = 'CreateRfidCardDialogContentComponent';

  @Input() private customerId: number;

  @ViewChild('createRfidCardComponent') createRfidCardComponent: CreateRfidCardComponent;

  constructor(
    public activeModal: NgbActiveModal,
    public rfidCardsService: RfidCardsService,
    public formService: FormService,
    injector: Injector) {
    super(activeModal, injector);
  }

  ngAfterViewInit() {
    this.createRfidCardComponent.customerId = this.customerId;
  }
}
